import { ContactRole, StoreContact } from '../../graphql/generatedTypes';

const COMMUNICATOR_DEPARTMENT = 'communicator';

export const isCommunicator = (contact: Partial<StoreContact>): boolean => {
  if (Array.isArray(contact?.contact_departments)) {
    if (
      contact.contact_departments.some(
        (d) => d?.toLowerCase() === COMMUNICATOR_DEPARTMENT,
      )
    ) {
      return true;
    }
  }
  if (Array.isArray(contact?.roles)) {
    return contact.roles.includes(ContactRole.Communicator);
  }
  return false;
};
